module.exports = __webpack_public_path__ + "img/floppy-disk.d1f7728e.svg";